// extracted by mini-css-extract-plugin
export default {"lineButtons":"realEstateItem_lineButtons__7tDj5","headers":"realEstateItem_headers__FO7kQ","twoInLine":"realEstateItem_twoInLine__cP9HM"};